import { useState } from 'react';
export const useCustomReportValues = (values: readonly string[], multiple: boolean, onChange: (values: readonly string[]) => void) => {
  const [input, setInput] = useState('');
  return {
    input,
    setInput,
    add: () => {
      if (input.trim()) {
        onChange(multiple ? [...new Set([...values, input.trim()])] : [input.trim()]);
        setInput('');
      }
    },
    remove: (index: number) => onChange(values.filter((_, position) => position !== index))
  };
};
